import {processModule} from '@/store/process/process';

export async function progress(func: () => Promise<void>) {
    if (processModule.処理中) {
        return;
    }
    await processModule.開始する();
    try {
        await func();
    } finally {
        await processModule.終了する();
    }
}
